import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CampaignSegmentService {

  constructor(private api: ApiService) { }

  getAllCampaignSegmentTypes(data: any): Observable<any> {
    return this.api.post(environment.getAllCampaignSegmentTypes, data);
  }

  createCampaignSegmentType(data: any): Observable<any> {
    return this.api.post(environment.createCampaignSegmentType, data);
  }

  updateCampaignSegmentType(data: any): Observable<any> {
    return this.api.post(environment.updateCampaignSegmentType, data);
  }

  deleteCampaignSegmentType(data: any): Observable<any> {
    return this.api.post(environment.deleteCampaignSegmentType, data);
  }
}
